<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="trial-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="experimentNumber"
                label="Experiment Number"
                width="95"
            />
            <el-table-column
                prop="trialNumber"
                label="Trial Number"
                min-width="100"
            >
                <template slot-scope="scope">
                    <a :href="'/trial/trial-detail/'+scope.row.id" class="tableLinkID" :data-passingID="scope.row.id" data-detailPage="TrialDetail">{{ scope.row.trialNumber }}</a>
                </template>
            </el-table-column>
            <el-table-column
                prop="yearLaidDown"
                label="Year Laid Down"
                width="70"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
import { trialGetAll } from "@/api/trial";

export default {
    props: {
        id: {
            type: String | Number
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        id: {
            immediate: true,
            handler() {
                this.getAllTrial();
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
        async getAllTrial () {
            this.isLoading = true;
            let res = await trialGetAll({ "ProgenyId": this.id, "DisablePaging": true });
            if (res) {
                this.tableData = res.items;
            }
            this.isLoading = false;
        },
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Trial/TrialSimpleTable.vue